// extracted by mini-css-extract-plugin
export default {"body":"styles_body__-qbFV","title":"styles_title__sVkMH","subtitle":"styles_subtitle__vvaW7","content":"styles_content__Yrxlq"};